// @ts-check
/**
 * Typed client for the entities API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['Entity']} Entity */
/** @typedef {Schemas['EntityAttribute']} EntityAttribute */
/** @typedef {Schemas['EntityUpdateFieldRequest']} EntityUpdateFieldRequest */
/** @typedef {Schemas['EntityUpdateFieldResponse']} EntityUpdateFieldResponse */

/**
 * GET /api/entities/{id}/ — fetch entity details including attribute values.
 * @param {number} id
 * @returns {Promise<Entity>}
 */
export async function getEntity(id) {
  const { data } = await axios.get(`/api/entities/${id}/`)
  return data
}

/**
 * GET /api/entity-attributes/ — fetch attribute definitions for an entity type.
 * @param {number} entityTypeId
 * @returns {Promise<EntityAttribute[]>}
 */
export async function getEntityAttributeDefinitions(entityTypeId) {
  const { data } = await axios.get('/api/entity-attributes/', {
    params: { entity_type_id: entityTypeId },
  })
  return data
}

/**
 * Fetch entity details and attribute definitions in sequence, then merge into
 * a single attributes dict with a `_defined_attributes` list so consumers can
 * distinguish "attribute not defined for this entity type" from "defined but
 * no value set yet."
 *
 * @param {number} entityId
 * @returns {Promise<{ attributes: Record<string, any>, entity: Entity }>}
 */
export async function getEntityWithAttributeDefinitions(entityId) {
  const entity = await getEntity(entityId)
  const definitions = await getEntityAttributeDefinitions(entity.entity_type)
  const attributes = entity.attributes || {}
  attributes['_defined_attributes'] = definitions.map((d) => d.name)
  return { attributes, entity }
}
